import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
`;

export const IconContainer = styled.div`
  cursor: pointer;
  margin: 20px;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;